var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyTelegramRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_10166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#585C6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09992 12.709C7.39488 10.7333 10.2589 9.4308 11.6919 8.80149C15.7834 7.00467 16.6335 6.69255 17.1877 6.68224C17.3095 6.67997 17.5821 6.71186 17.7586 6.86309C17.9076 6.99079 17.9486 7.16329 17.9683 7.28436C17.9879 7.40543 18.0123 7.68123 17.9929 7.89673C17.7712 10.3564 16.8118 16.3255 16.3237 19.0804C16.1172 20.2461 15.7105 20.6369 15.3169 20.6752C14.4613 20.7583 13.8116 20.0782 12.9829 19.5047C11.6862 18.6072 10.9537 18.0485 9.69503 17.1728C8.24043 16.1607 9.18338 15.6045 10.0124 14.6954C10.2293 14.4575 13.999 10.8372 14.0719 10.5088C14.0811 10.4677 14.0895 10.3146 14.0034 10.2338C13.9172 10.1529 13.7901 10.1806 13.6983 10.2026C13.5683 10.2337 11.4968 11.6794 7.48389 14.5394C6.89591 14.9657 6.36333 15.1734 5.88616 15.1626C5.36012 15.1506 4.34822 14.8485 3.59598 14.5903C2.67333 14.2737 1.94002 14.1063 2.00388 13.5685C2.03714 13.2883 2.40248 13.0019 3.09992 12.709Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_10166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTelegramRounded);
export default __webpack_public_path__ + "static/media/grey-TelegramRounded.c30992cd3b2f1730f0214225d5029b97.svg";
export { ForwardRef as ReactComponent };